import { getHubEnabled } from '../utils/storage';

import { AblyClient } from './ablyClient';
import { HubLocalSocketClient } from './hubSocketClient';

export class SocketClient extends AblyClient {
  private localSocketConnection = new HubLocalSocketClient();

  public async connect() {
    super.connect();

    if (!getHubEnabled()) {
      return;
    }
    await this.localSocketConnection.connect(this.channelName);
  }
}

const instance = new SocketClient();

export default instance;

window.socketClient = instance;
